import type { ReactNode } from 'react';
import { Link as Control } from 'react-router-dom';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface NavLinkProps {
  className?: string;
  to: string;
  title: string;
  icon: ReactNode;
}

export const NavLink = (props: NavLinkProps) => {
  return (
    <Control
      className={cn(
        'flex items-center gap-3 p-6 text-inherit no-underline transition-shadow duration-200',
        'hover:shadow-lg dark:hover:shadow-lg-dark',
        PaletteUtils.isVcfcPalette && 'bg-ghost-white dark:bg-eerie-black',
        PaletteUtils.isInsigniaPalette && 'bg-white dark:bg-soft-black',
        props.className,
      )}
      to={props.to}
    >
      <div
        className={cn(
          'flex h-12 w-12 flex-none items-center justify-center rounded-3xl text-ice dark:bg-primary',
          PaletteUtils.isInsigniaPalette && 'bg-soft-black',
          PaletteUtils.isVcfcPalette && 'bg-primary',
        )}
      >
        {props.icon}
      </div>
      <Text className={cn(PaletteUtils.isInsigniaPalette && 'dark:!text-primary')} weight='semibold' size='xl'>
        {props.title}
      </Text>
    </Control>
  );
};
